import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { Observable } from 'rxjs';
import { toParams } from '../../utilities/utility-functions';
import { ICityDto } from './../../models/city-dto';

@Injectable({
  providedIn: 'root',
})
export class AgenciaService {
  #baseUrl = environment.apiUrl + '/v1/agencias';
  #http = inject(HttpClient);

  buscarAgencias(
    filter: IAgenciaFilter,
    pageable: IPageable,
  ): Observable<IPage<IAgenciaDto>> {
    const params = toParams(filter, pageable);
    return this.#http
      .get<IResponseDto<IPage<IAgenciaDto>>>(this.#baseUrl, { params })
      .pipe(extractResponse());
  }

  buscarAgenciaPorId(ageNrId: number): Observable<IAgenciaDto> {
    return this.#http
      .get<IResponseDto<IAgenciaDto>>(this.#baseUrl + `/${ageNrId}`)
      .pipe(extractResponse());
  }
}
export interface IAgenciaDto {
  ageNrId: number;
  ageTxNome: string;
  ageTxCodigo: string;
  banNrId: number;
  cidadeDto: ICityDto;
}
export interface IAgenciaFilter {
  ageTxNome: string;
  ageTxCodigo: string;
  cidNrId: number;
  banNrId: number;
}
